import axiosInstance from "../config/API";

const API_ENDPOINT = "/complaint.php";

// Fetch all complaints and dropdown data (customers, staff)
export const fetchComplaintsApi = async (searchText = "") => {
  const payload = {
    action: "list",
    search_text: searchText,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("fetch complaints:", response.data);
  return response.data.body || { complaints: [], customers: [], staff: [] };
};

// Add a new complaint
export const addComplaintApi = async (complaintData) => {
  const payload = {
    action: "create",
    customer_id: complaintData.customer_id,
    staff_id: complaintData.staff_id,
    description: complaintData.description,
    current_user_id: complaintData.current_user_id,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("add complaint:", response.data);
  return response.data;
};

// Update a complaint
export const updateComplaintApi = async (complaintData) => {
  const payload = {
    action: "update",
    complaint_id: complaintData.complaint_id,
    staff_id: complaintData.staff_id,
    description: complaintData.description,
    status: complaintData.status,
    current_user_id: complaintData.current_user_id,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("update complaint:", response.data);
  return response.data;
};

// Delete a complaint
export const deleteComplaintApi = async (complaintId, currentUserId) => {
  const payload = {
    action: "delete",
    complaint_id: complaintId,
    current_user_id: currentUserId,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("delete complaint:", response.data);
  return response.data;
};
